import React from 'react';
import { Link } from 'react-router-dom';
import './Gallery.css';

const Gallery = () => {

  const events = [
    {
      id: 2,
      title: "Amegnona Gathering 2025",
      description: "Our latest gathering celebrating unity, brotherhood, and the continued strength of our community bonds. A memorable event showcasing our growth and solidarity.",
      images: 345
    },
    {
      id: 1,
      title: "Community Gathering 2022", 
      description: "A celebration bringing members together in solidarity and brotherhood, sharing moments of joy and community spirit.",
      images: 13
    }
  ];


  return (
    <div className="gallery">
      <section className="gallery-header">
        <div className="container">
          <h1>Events</h1>
          <p className="gallery-subtitle">
            Discover our community gatherings and celebrations
          </p>
        </div>
      </section>

      {/* Events Section */}
      <section className="events-section">
        <div className="events-grid">
          {events.map(event => (
            <Link key={event.id} to={`/events/${event.id}`} className="event-card-link">
              <div className="event-card">
                <div className="event-image">
                  <img src={event.id === 2 ? "/event-pics/event2/EZ8A5575.JPG" : "/event-pics/event1/PHOTO-2022-12-20-23-42-40.jpg"} alt={event.title} className="event-photo" />
                  <div className="event-overlay">
                    <span className="photo-count">{event.images} Photos</span>
                  </div>
                </div>
                <div className="event-content">
                  <h3>{event.title}</h3>
                  <p className="event-description">{event.description}</p>
                  <div className="event-action">
                    <span className="view-link">View Event →</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Gallery;